/*
Akhila 11/19/2022 2700271704 Created new Component
Prakash 11/22/2022 2700271704 Added  card spacing.
Sohel 11/23/2022 2700271704 Added Alert Popup
Akhila 05/31/2023 2700271704 unsaved changes bug fixed
*/
import React, {useState, useContext, useRef} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {ThemeContext} from '../../../themes/ThemeProvider';
import SearchAccountTrigger from './SearchAccountTrigger';
import AddTriggerAccount from './AddTriggerAccount';
import SaveAlert from '../../../components/DialogBox/SaveAlert';
import SelectTabContextProvider from '../../../components/SelectTabContext/SelectTabContext';
import useUnsavedChangesWarning from '../../../util/CustomHooks';

const useStyles = makeStyles((theme) => ({
  'root': {
    flexGrow: 1,
    width: '100%',
    borderRadius: '5px',
  },
  'MuiTabScrollButton-root': {
    color: 'black',
  },
  'demo1': {
    color: 'white',
    borderRadius: '6px',
  },
}));

export default function TriggerAccountSubTabs() {
  const classes = useStyles();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes1 = reusableInputStyles();
  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const showAlertRef = useRef(false);
  const {onDirty, onPristine} = useUnsavedChangesWarning();
  const {setGlobalFieldRow, sample, setNewTabValue} =
    useContext(SelectTabContextProvider);
  const changeDirty = useRef(true);
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }
    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };

  const handleTabChange = (event, newValue) => {
    if (value === 1 && sample && newValue === 0) {
      setOpen(true);
      setNewTabValue(newValue);
    } else {
      setValue(newValue);
    }
    setGlobalFieldRow(false);
  };
  return (
    <div className={`${classes1.cardStyleWhite}`}>
      <div className={classes.root}>
        <div className={classes.subContent}>
          {open && (
            <SaveAlert setTabValue={setValue} setOpen={setOpen} open={open} tabvalue={value} />
          )}
          {value === 0 && <SearchAccountTrigger setValue={setValue} />}
          {value === 1 && (
            <AddTriggerAccount
              setTabValue={setValue}
              value={value}
              handleTabChange={handleTabChange}
              {...alertProps}
            />
          )}
        </div>
      </div>
    </div>
  );
}
